import { createFileRoute } from "@tanstack/react-router";
import AlcoholAddictionTreatmentCherryHillNJ from "@/pages/AlcoholAddictionTreatmentCherryHillNJ";
import { routeHead } from "@/lib/route-head";

export const Route = createFileRoute("/alcohol-addiction-treatment-cherry-hill-nj")({
  head: () => routeHead("/alcohol-addiction-treatment-cherry-hill-nj"),
  component: AlcoholAddictionTreatmentCherryHillNJ,
});
